/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled, { css } from 'styled-components';
import { media } from '@exo/frontend-common-style-utils';
import { ColProps, getColWidth, isPartialWidth, isFullWidth, isHidden } from './ColumnStyleUtils';



export const Column = styled('div')<ColProps>`
  ${props => css`
    ${isFullWidth(props, 'sm') &&
      `
      flex-basis: 100%;
      flex-grow: 1;
      max-width: 100%;
    `}
    ${isPartialWidth(props, 'sm') &&
      `
      flex: 0 0 ${getColWidth(props, 'sm')}%;
      max-width: ${getColWidth(props, 'sm')}%;
    `}
    ${isHidden(props, 'sm') &&
      'display: none;'
    }
  `}

  ${props => media.greaterThan(props, 'medium').then(css`
    ${isFullWidth(props, 'md') &&
      `
      flex-basis: 100%;
      flex-grow: 1;
      max-width: 100%;
    `}
    ${isPartialWidth(props, 'md') &&
      `
      flex: 0 0 ${getColWidth(props, 'md')}%;
      max-width: ${getColWidth(props, 'md')}%;
    `}
    ${isHidden(props, 'md') && 'display: none;' }
    ${!isHidden(props, 'md') && 'display: block;' }
  `)}

  ${props => media.greaterThan(props, 'large').then(css`
    ${isFullWidth(props, 'lg') &&
      `
      flex-basis: 100%;
      flex-grow: 1;
      max-width: 100%;
    `}
    ${isPartialWidth(props, 'lg') &&
      `
      flex: 0 0 ${getColWidth(props, 'lg')}%;
      max-width: ${getColWidth(props, 'lg')}%;
    `}
    ${isHidden(props, 'lg') && 'display: none;' }
    ${!isHidden(props, 'lg') && 'display: block;' }
  `)}

  ${props => media.greaterThan(props, 'xLarge').then(css`
    ${isFullWidth(props, 'xl') &&
      `
      flex-basis: 100%;
      flex-grow: 1;
      max-width: 100%;
    `}
    ${isPartialWidth(props, 'xl') &&
      `
      flex: 0 0 ${getColWidth(props, 'xl')}%;
      max-width: ${getColWidth(props, 'xl')}%;
    `}
    ${isHidden(props, 'xl') && 'display: none;' }
    ${!isHidden(props, 'xl') && 'display: block;' }
  `)}

  ${props => media.greaterThan(props, 'max').then(css`
    ${isFullWidth(props, 'max') &&
      `
      flex-basis: 100%;
      flex-grow: 1;
      max-width: 100%;
    `}
    ${isPartialWidth(props, 'max') &&
      `
      flex: 0 0 ${getColWidth(props, 'max')}%;
      max-width: ${getColWidth(props, 'max')}%;
    `}
    ${isHidden(props, 'max') && 'display: none;' }
    ${!isHidden(props, 'max') && 'display: block;' }
  `)}
`;
